import React from 'react';
import {
  Box,
  Container,
  VStack,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import ResetPasswordForm from '../components/ResetPasswordForm';

const ResetPasswordView = ({ onResetPasswordSubmit }) => {
  const { token } = useParams();

  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="center">
        <Box w="100%" maxW="400px">
          <ResetPasswordForm onSubmit={onResetPasswordSubmit} token={token} />
        </Box>
      </VStack>
    </Container>
  );
};

export default ResetPasswordView;
